import React from 'react';
import { BreadcrumbsItem } from '@cp/ds/src/components/breadcrumbs';
// import { useCurrentCity } from '@cp/entities/location';
import { /* useClientWebRouteParams, */ usePathGenerator } from '@cp/entities/clientWebRoutes';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { ROUTES_DEFAULT_CITY_ALIAS } from '@common/const/routes/defaultCity';

export const useBaseBreadcrumbs = (): BreadcrumbsItem[] => {
  // const { hasCitySeparatedContent } = useClientWebRouteParams();
  // const { currentCity } = useCurrentCity({ allowEmptyValue: true });
  const generateAppPath = usePathGenerator();

  return React.useMemo(() => {
    const breadcrumbs: BreadcrumbsItem[] = [
      {
        path: generateAppPath({ page: ClientWebPage.Home, pathParams: { city: ROUTES_DEFAULT_CITY_ALIAS } }),
        label: 'Главная',
      },
    ];

    // if (hasCitySeparatedContent && currentCity && currentCity.alias !== ROUTES_DEFAULT_CITY_ALIAS) {
    //   breadcrumbs.push({
    //     path: generateAppPath({ page: ClientWebPage.Home }),
    //     label: currentCity.translation.name,
    //   });
    // }

    return breadcrumbs;
  }, [generateAppPath]);
};
